module.exports = __webpack_public_path__ + "img/pintecCredit.47fee569.png";